// extracted by mini-css-extract-plugin
module.exports = {"carNumberPosition":"CarNumberPosition_carNumberPosition__2vQqh","inspector":"CarNumberPosition_inspector__2fJIm"};